import { useEffect, useState } from "react";

const RESEND_COOLDOWN_SECONDS = 30;

export const useResendCooldown = () => {
	const [cooldownSeconds, setCooldownSeconds] = useState(0);

	useEffect(() => {
		if (cooldownSeconds <= 0) {
			return;
		}

		const intervalId = setInterval(() => {
			setCooldownSeconds((secondsLeft) => Math.max(0, secondsLeft - 1));
		}, 1000);

		return () => clearInterval(intervalId);
	}, [cooldownSeconds]);

	return { cooldownSeconds, resetCooldown: () => setCooldownSeconds(RESEND_COOLDOWN_SECONDS) };
};
